import {Android, Apple, Launch} from '@mui/icons-material';
import {Button} from '@mui/material';
import React, {useLayoutEffect, useState, useEffect} from 'react';
import {useMediaQuery} from 'react-responsive';
import styled, {keyframes} from 'styled-components';

const fadeIn = keyframes`
  0% {
    transform : translateY(3em);
    opacity: 0;
  }
  50% {
    transform : translateY(3em);
    opacity: 0;
  }
  100% {
    transform : translateY(0em);
    opacity: 1;
  }
`;

const fadeInX = keyframes`
  0% {
    transform : translateX(-10em);
    opacity: 0;
  }
  50% {
    transform : translateX(-10em);
    opacity: 0;
  }
  100% {
    transform : translateX(0em);
    opacity: 1;
  }
`;

const EnterDiv = styled.div`
  animation-fill-mode: forwards;
  animation: 1000ms ${fadeIn} linear;
`;

const EnterXDiv = styled.div`
  animation-fill-mode: forwards;
  animation: 1000ms ${fadeInX} linear;
`;

const Banner = () => {
  const isSmall = useMediaQuery({query: '(max-width: 750.98px)'});
  const isVerySmall = useMediaQuery({query: '(max-width:450.00px)'});
  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }
  // eslint-disable-next-line no-unused-vars
  const [width, height] = useWindowSize();

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  useEffect(() => {
    const rawMode = getParameterByName('mode');
    const id = getParameterByName('id');

    const mode = rawMode ? `redirect_${rawMode}` : 'redirect_unknown';
    const src = id ? id : `noid_${mode}_${Date.now()}`; // fallback src com timestamp

    if (mode && src) {
      fetch(
        `https://ireit.com.br/track.php?src=${encodeURIComponent(
          src,
        )}&mode=${encodeURIComponent(mode)}`,
      )
        .then(() => {
          // Redireciona após o rastreamento
        })
        .catch(err => {
          console.error('Erro ao rastrear acesso:', err);
        });
    }
  }, []);

  function openDeepLink() {
    const mode = getParameterByName('mode');
    const id = getParameterByName('id');

    const universalLink = (() => {
      switch (mode) {
        case 'carona':
          return id
            ? `https://ireit.com.br/carona/${id}`
            : 'https://ireit.com.br/carona';
        case 'order':
          return id
            ? `https://ireit.com.br/order/${id}`
            : 'https://ireit.com.br/order';
        case 'loja':
          return id
            ? `https://ireit.com.br/loja/${id}`
            : 'https://ireit.com.br/loja';
        case 'acompanhamento':
          return id
            ? `https://ireit.com.br/acompanhamento/${id}`
            : 'https://ireit.com.br/acompanhamento';
        case 'maindelivery':
        case 'delivery':
          return 'https://ireit.com.br/delivery';
        default:
          return 'https://ireit.com.br';
      }
    })();

    const userAgent = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(userAgent) && !window.MSStream;
    const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    const isAndroid = /Android/.test(userAgent);

    // Define o tempo para considerar que o app não abriu
    const FALLBACK_DELAY = 1500;

    let fallbackTimer;

    if (isIOS && isSafari) {
      // iOS Safari → tenta abrir universal link
      // Se o app estiver instalado, ele abrirá
      // Se não, cairá no setTimeout abaixo
      window.location.href = universalLink;

      fallbackTimer = setTimeout(() => {
        // Se chegou aqui, o app provavelmente não abriu
        alert(
          'Para acessar essa área (loja, pedidos, carona ou entrega), é necessário ter o aplicativo Irê It instalado no seu dispositivo.\n\nClique no botão abaixo para baixar o app ou abrir diretamente, se já tiver.',
        );
        // Aqui você pode renderizar botões ou redirecionar para App Store
      }, FALLBACK_DELAY);
    } else if (isAndroid) {
      // Android → tenta via schema
      const appLink = (() => {
        switch (mode) {
          case 'carona':
            return id ? `ireit://carona/${id}` : 'ireit://carona';
          case 'order':
            return id ? `ireit://order/${id}` : 'ireit://order';
          case 'maindelivery':
            return 'ireit://maindelivery';
          case 'acompanhamento':
            return id
              ? `ireit://acompanhamento/${id}`
              : 'ireit://acompanhamento';
          case 'loja':
            return id ? `ireit://loja/${id}` : 'ireit://loja';
          default:
            return 'ireit://inicio';
        }
      })();

      window.location.href = appLink;

      fallbackTimer = setTimeout(() => {
        alert(
          'Para acessar essa área (loja, pedidos, carona ou entrega), é necessário ter o aplicativo Irê It instalado no seu dispositivo.\n\nClique no botão abaixo para baixar o app ou abrir diretamente, se já tiver.',
        );
      }, FALLBACK_DELAY);
    } else {
      // Outros navegadores ou desktop
      alert(
        'Para acessar essa área (loja, pedidos, carona ou entrega), é necessário ter o aplicativo Irê It instalado no seu dispositivo.\n\nAcesse via dispositivo móvel.',
      );
    }

    // Limpa o timer se sair da página antes
    window.addEventListener('pagehide', () => clearTimeout(fallbackTimer));
    window.addEventListener('blur', () => clearTimeout(fallbackTimer)); // iOS 15+
  }

  return (
    <div style={{width: width, height: 'auto'}}>
      {isVerySmall || isSmall ? (
        <div
          style={{
            background: 'linear-gradient(#06448e, #7c53e3, #b553e3)',
            width: '100%',
            height: 'auto',
            marginTop: 60,
            display: 'flex',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: width,
              marginBottom: 60,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <p
              style={{
                fontSize: 30,
                width: 'auto',
                marginLeft: 30,
                marginRight: 30,
                marginTop: 20,
                fontWeight: 'bold',
                color: '#FFFFFF',
                textAlign: 'center',
              }}
            >
              Abrir o aplicativo da Irê it?
            </p>
            <p
              style={{
                fontSize: 18,
                width: '70%',
                marginLeft: 0,
                marginTop: 0,
                fontWeight: 'bold',
                color: '#FFFFFF',
                textAlign: 'center',
              }}
            >
              Você acessou um link que precisa abrir no app da Irê It. Instale o
              app ou toque abaixo para continuar.
            </p>
            <Button
              onClick={() => openDeepLink()}
              style={{
                textTransform: 'none',
                width: '70%',
                height: 60,
                fontWeight: 'normal',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 10,
                marginBottom: 0,
              }}
              sx={{
                color: '#ffffff',
                bgcolor: '#FF6600',
                ':hover': {
                  bgcolor: '#FFFFFF',
                  color: '#FF6600',
                },
              }}
            >
              <Launch />
              <div style={{marginLeft: 10}}>
                <p
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    justifyContent: 'flex-start',
                    textAlign: 'left',
                  }}
                >
                  Abrir app
                </p>
                <p
                  style={{
                    marginTop: -10,
                    marginBottom: 0,
                    justifyContent: 'flex-start',
                    textAlign: 'left',
                    fontSize: 20,
                  }}
                >
                  Irê it
                </p>
              </div>
            </Button>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 50,
                width: '100%',
              }}
            >
              <Button
                style={{
                  textTransform: 'none',
                  width: '70%',
                  height: 60,
                  fontWeight: 'normal',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                sx={{
                  color: '#ffffff',
                  bgcolor: '#06448e',
                  ':hover': {
                    color: '#ffffff',
                    bgcolor: '#06448e',
                  },
                }}
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.ireit&hl=pt"
              >
                <Android />
                <div style={{marginLeft: 10}}>
                  <p
                    style={{
                      marginTop: 0,
                      marginBottom: 0,
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                      fontSize: 12,
                    }}
                  >
                    Disponível na
                  </p>
                  <p
                    style={{
                      marginTop: -10,
                      marginBottom: 0,
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                      fontSize: 14,
                    }}
                  >
                    Play Store
                  </p>
                </div>
              </Button>
              <Button
                style={{
                  textTransform: 'none',
                  width: '70%',
                  height: 60,
                  fontWeight: 'normal',
                  alignItems: 'center',
                  marginTop: 20,
                  marginBottom: 100,
                }}
                sx={{
                  color: '#06448e',
                  bgcolor: '#ffffff',
                  ':hover': {
                    color: '#06448e',
                    bgcolor: '#ffffff',
                  },
                }}
                target="_blank"
                href="https://apps.apple.com/br/app/ir%C3%AA-it/id6475050868"
              >
                <Apple />
                <div style={{marginLeft: 10}}>
                  <p
                    style={{
                      marginTop: 0,
                      marginBottom: 0,
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                      fontSize: 12,
                    }}
                  >
                    Disponível na
                  </p>
                  <p
                    style={{
                      marginTop: -10,
                      marginBottom: 0,
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                      fontSize: 14,
                    }}
                  >
                    Apple Store
                  </p>
                </div>
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            background: 'linear-gradient(#06448e, #7c53e3, #aa3cc9)',
            width: '100%',
            height: 'auto',
            marginTop: 60,
            display: 'flex',
            paddingBottom: 60,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <p
              style={{
                fontSize: 48,
                width: '100%',
                marginLeft: 0,
                marginTop: 60,
                fontWeight: 'bold',
                color: '#FFFFFF',
                textAlign: 'center',
              }}
            >
              Abrir o aplicativo da Irê it?
            </p>
            <EnterXDiv>
              <p
                style={{
                  fontSize: 28,
                  width: '100%',
                  marginLeft: 0,
                  marginTop: 10,
                  fontWeight: 'bold',
                  color: '#FFFFFF',
                  textAlign: 'center',
                }}
              >
                Você acessou um link que precisa abrir no app da Irê It. Instale
                o app ou toque abaixo para continuar.
              </p>
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Button
                  onClick={() => openDeepLink()}
                  style={{
                    marginRight: 10,
                    textTransform: 'none',
                    width: 180,
                    height: 60,
                    fontWeight: 'normal',
                    alignItems: 'center',
                    marginLeft: 30,
                  }}
                  sx={{
                    color: '#ffffff',
                    bgcolor: '#06448e',
                    ':hover': {
                      bgcolor: '#FFFFFF',
                      color: '#06448e',
                    },
                  }}
                >
                  <Launch />
                  <div style={{marginLeft: 10}}>
                    <p
                      style={{
                        marginTop: 0,
                        marginBottom: 0,
                        justifyContent: 'flex-start',
                        textAlign: 'left',
                      }}
                    >
                      Abrir app
                    </p>
                    <p
                      style={{
                        marginTop: -10,
                        marginBottom: 0,
                        justifyContent: 'flex-start',
                        textAlign: 'left',
                        fontSize: 20,
                      }}
                    >
                      Irê it
                    </p>
                  </div>
                </Button>
              </div>
            </EnterXDiv>

            <EnterDiv
              style={{
                display: 'flex',
                marginTop: 160,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Button
                style={{
                  marginRight: 10,
                  textTransform: 'none',
                  width: 180,
                  height: 60,
                  fontWeight: 'normal',
                  alignItems: 'center',
                  marginLeft: 30,
                }}
                sx={{
                  color: '#ffffff',
                  bgcolor: '#ff6600',
                  ':hover': {
                    bgcolor: '#FFFFFF',
                    color: '#FF6600',
                  },
                }}
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.ireit&hl=pt"
              >
                <Android />
                <div style={{marginLeft: 10}}>
                  <p
                    style={{
                      marginTop: 0,
                      marginBottom: 0,
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                    }}
                  >
                    Disponível na
                  </p>
                  <p
                    style={{
                      marginTop: -10,
                      marginBottom: 0,
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                      fontSize: 20,
                    }}
                  >
                    Play Store
                  </p>
                </div>
              </Button>
              <Button
                style={{
                  marginRight: 10,
                  textTransform: 'none',
                  width: 180,
                  height: 60,
                  fontWeight: 'normal',
                  alignItems: 'center',
                  marginLeft: 30,
                }}
                sx={{
                  color: '#ffffff',
                  bgcolor: '#ff6600',
                  ':hover': {
                    bgcolor: '#FFFFFF',
                    color: '#FF6600',
                  },
                }}
                target="_blank"
                href="https://apps.apple.com/br/app/ir%C3%AA-it/id6475050868"
              >
                <Apple />
                <div style={{marginLeft: 10}}>
                  <p
                    style={{
                      marginTop: 0,
                      marginBottom: 0,
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                    }}
                  >
                    Disponível na
                  </p>
                  <p
                    style={{
                      marginTop: -10,
                      marginBottom: 0,
                      justifyContent: 'flex-start',
                      textAlign: 'left',
                      fontSize: 20,
                    }}
                  >
                    Apple Store
                  </p>
                </div>
              </Button>
            </EnterDiv>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banner;
